import { StringOptions } from "../../../../../components/Select";
import { DEFAULT_HOLDING_SORT, HOLDING_SORT_LABELS } from "./constants";
import { HoldingSortKey, HoldingSortState, SortDir } from "./types";

// Taken off the exhaustive label map rather than listed again, so a seventh sort key
// reaches the mobile select without anyone remembering to add it here.
const SORT_KEYS = Object.keys(HOLDING_SORT_LABELS) as HoldingSortKey[];

export const sortStateToValue = ({ key, dir }: HoldingSortState): string =>
  `${key}:${dir}`;

const optionsFor = (key: HoldingSortKey): StringOptions[] =>
  (["desc", "asc"] as SortDir[]).map((dir) => ({
    label: `${dir === "desc" ? "↓" : "↑"} ${HOLDING_SORT_LABELS[key]}`,
    value: sortStateToValue({ key, dir }),
  }));

// Card list (mobile) sort is a single select, so each sortable dimension is
// flattened into an explicit direction. Mirrors the desktop table sort keys.
export const SORT_OPTIONS: StringOptions[] = SORT_KEYS.flatMap(optionsFor);

export const valueToSortState = (value: string): HoldingSortState => {
  const [key, dir] = value.split(":");
  const sortKey = SORT_KEYS.find((candidate) => candidate === key);

  return {
    key: sortKey ?? DEFAULT_HOLDING_SORT.key,
    dir: dir === "asc" ? "asc" : "desc",
  };
};
